import { Link } from "react-router-dom";
import "../../assets/css/container/main/Footer.css";

const Footer: React.FC = () => {
	return (
		<footer className="Footer">
			<div className="footer-inner">

				{/* 브랜드 */}
				<div className="footer-brand">
					<h2 className="footer-logo">FactWeb</h2>
					<p className="footer-slogan">
						팩트는 믿음이 아니라 검증으로 완성됩니다
					</p>
				</div>

				{/* 링크 영역 */}
				<div className="footer-links">
					<div className="footer-col">
						<h4>서비스</h4>
						<ul>
							<li><Link to="/">팩트 목록</Link></li>
							<li><Link to="/categories">카테고리</Link></li>
							<li><Link to="/notices">공지사항</Link></li>
							<li><Link to="/freeboard">자유게시판</Link></li>
							<li><Link to="/writeNew">팩트 작성</Link></li>
						</ul>
					</div>

					<div className="footer-col">
						<h4>정책</h4>
						<ul>
							<li><Link to="/policy/terms">이용약관</Link></li>
							<li><Link to="/policy/privacy">개인정보처리방침</Link></li>
							<li><Link to="/policy/operation">운영정책</Link></li>
							<li><Link to="/policy/verification">콘텐츠 검증 기준</Link></li>
						</ul>
					</div>

					<div className="footer-col">
						<h4>운영</h4>
						<ul>
							<li><Link to="/about">운영자 소개</Link></li>
							<li><Link to="/updates">업데이트 내역</Link></li>
							<li>
								<a href="mailto:contact@factweb.co.kr">
									문의하기
								</a>
							</li>
						</ul>
					</div>
				</div>

				{/* 하단 */}
				<div className="footer-bottom">
					<p className="footer-notice">
						FactWeb은 사실 검증과 근거 중심의 토론을 지향합니다.
						모든 콘텐츠는 이용자에 의해 작성되며 운영진의 공식 입장이 아닐 수 있습니다.
					</p>
					<p className="footer-copy">
						© {new Date().getFullYear()} FactWeb. All rights reserved.
					</p>
				</div>

			</div>
		</footer>
	);
};

export default Footer;
